import { ObjectType, Field, Int } from '@nestjs/graphql'
import { ArcWithStatsDto } from './arcWithStats.model.dto'

@ObjectType()
export class ArcWebStatsDto {
  @Field(type => Int)
  arcReviewCount!: number

  @Field(type => Int)
  arcReviewUserCount!: number

  @Field(type => Int, { nullable: true })
  userCount?: number

  @Field(type => Int)
  arcLiveCount!: number

  @Field(type => Int)
  arcActiveCount!: number

  @Field(type => Int)
  authorCount!: number

  @Field(type => Int, { nullable: true })
  totalArcCount?: number

  /** The signed-in author's scheduled campaigns, counted as ARCS.MAX_SCHEDULED counts them [sc-29193]. */
  @Field(type => Int, { nullable: true })
  scheduledArcCount?: number

  @Field(t => ArcWithStatsDto)
  topArc!: ArcWithStatsDto
}
